//

export const loadingState = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  LOADED_ALL: 'LOADED_ALL',
  FAILED: 'FAILED'
}
